<template>
  <div>
  <v-row>
      <v-col cols="3" class="pt-0 pb-0">
          <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
          :taxYearValue="editedItem.taxYear"
          :key="`taxYear-${editedItem.taxYear}-${editedItem._id || 'new'}`"/>
          <v-text-field class="input-text-size pt-0" label="Tax ID"
          v-model.number="editedItem.taxId"
          @blur="handleTaxRollRecords"
            :readonly="!!editedItem._id" :tabindex="editedItem._id ? -1 : 0"
           hide-details :rules="required" />
          <label class="input-text-size headers-color">
            {{ownerInfo.name || (editedItem.valuesBeforeAdjustment ?
             editedItem.valuesBeforeAdjustment.name:'')  }}</label>
          <ClarionDateControl
            class="input-text-size pa-0 mb-n3"
            :isToggle="false"
            :rules="adjRules"
            :isDisabled="!isNewRecord"
            v-model="intDate.adjDate"
            @input="(val) => dateChangeFunc(val, 'adjDate')"
            label="Date Entered"/>
            <ClarionDateControl
            class="input-text-size pa-0 mb-n5"
            :isToggle="false"
            :rules="certRules"
            @input="(val) => dateChangeFunc(val, 'certDate')"
            v-model="intDate.certDate"
            label="Certificate Date"
            />
            <ClarionDateControl
            class="input-text-size pa-0 mb-n2"
            :isToggle="false"
            @input="(val) => dateChangeFunc(val, 'filedDate')"
            v-model="intDate.filedDate"
            label="Filed Date"
            />
          <v-select
            v-model="editedItem.adjOrUpd"
            :items="adjUpdTypes"
            @change="handleAdjOrUpd"

            item-text="description"
            item-value="name"
            class="input-text-size pt-0 pb-0 mb-n5"
            :rules="rules"
            label="Adjust/Update"
          />
          <CommonDropDowns class="input-text-size pt-0 pb-0 mb-n6" :isItTaxAdjTypes=true
          @change="dataFromCommonDropDowns"
          :taxAdjTypesValue="editedItem.type" :taxAdjTypesRequired="true" />
          <v-row>
            <v-col cols="6">
              <v-text-field class="input-text-size pa-0" label="Certificate Number"
                v-model="editedItem.certNumber" hide-details />
            </v-col>
            <v-col cols="6">
              <v-text-field class="input-text-size pa-0" label="invoice Number"
                v-model.number="editedItem.invoiceNo" hide-details
                :readonly="!isNewRecord" :tabindex="!isNewRecord ? -1 : 0" />
            </v-col>
          </v-row>

          <v-checkbox class="input-text-size pa-0 mb-n2" label="Posted"
          v-model="editedItem.posted" :disabled="disabledPosted" />
          <v-btn
            color="error"
            small
            outlined
            class="mt-2"
            :disabled="!editedItem._id || editedItem.posted === 'Y' || editedItem.posted === true"
            @click="showDeleteConfirmation"
          >
            <v-icon small class="mr-1">{{ mdiDelete }}</v-icon>
            Delete
          </v-btn>
      </v-col>
      <v-col cols="9" class="pt-0 pb-0">
        <v-row>
          <v-col cols="3">
          </v-col>
          <v-col cols="3">
            <label class="input-text-size">Values Before Adjustment</label>
          </v-col>
          <v-col cols="3">
            <label class="input-text-size">Adjustment</label>
          </v-col>
          <v-col cols="3">
            <label class="input-text-size">Values After Adjustment</label>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0 ">
            <label class="input-text-size">Land</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.land}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input"
             hide-details
             v-model.number="editedItem.landVal"
             :value="adjustmentDifferent.landVal"
             @focus="amountToNumAdjustsVal('landVal'), $event.target.select()"
             @blur="(e)=>{adjustmentsValues(e.target.value,'land',ownerInfo.land,
             'landVal'), changeCalculatedTaxValues()}"
             :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             ></v-text-field>
          </v-col>

          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input" hide-details
            @focus="amountToNum('land'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'land',
            'landVal'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
            v-model.number="afterAdjustment.land"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0">
            <label class="input-text-size">Improvements</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.improvements}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input"
             hide-details
             @focus="amountToNumAdjustsVal('improvementVal'), $event.target.select()"
              @blur="(e)=>{adjustmentsValues(e.target.value,'improvements',
              ownerInfo.improvements,'improvementVal'), changeCalculatedTaxValues()}"
             v-model.number="editedItem.improvementVal"
              :value="adjustmentDifferent.improvementVal"
              :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             ></v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input" hide-details
            @focus="amountToNum('improvements'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'improvements',
            'improvementVal'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
            v-model.number="afterAdjustment.improvements"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0">
            <label class="input-text-size">Mobile Home</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.mobileHome}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input"
             hide-details
             v-model.number="editedItem.mobileVal"
              :value="adjustmentDifferent.mobileVal"
              @focus="amountToNumAdjustsVal('mobileVal'), $event.target.select()"
              @blur="(e)=>{adjustmentsValues(e.target.value,'mobileHome',
              ownerInfo.mobileHome,'mobileVal'), changeCalculatedTaxValues()}"
              :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             ></v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input" hide-details
            @focus="amountToNum('mobileHome'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'mobileHome',
            'mobileVal'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
            v-model.number="afterAdjustment.mobileHome"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0">
            <label class="input-text-size">Penalty</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.assessorPenalty}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field
            class="input-text-size pa-0 right-aligned-input"
            hide-details
            v-model.number="editedItem.penaltyVal"
            :value="adjustmentDifferent.penaltyVal"
            @focus="amountToNumAdjustsVal('penaltyVal'), $event.target.select()"
            @blur="(e)=>{adjustmentsValues(e.target.value,'assessorPenalty',
            ownerInfo.assessorPenalty,'penaltyVal'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             > </v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input" hide-details
            @focus="amountToNum('assessorPenalty'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'assessorPenalty',
            'penaltyVal'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             v-model.number="afterAdjustment.assessorPenalty" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0">
            <label class="input-text-size">Exemptions</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.exemptions}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input"
             hide-details
             v-model.number="editedItem.totalExemptions"
             @focus="amountToNumAdjustsVal('totalExemptions'), $event.target.select()"
             :value="adjustmentDifferent.totalExemptions"
             @blur="(e)=>{adjustmentsValues(e.target.value,'exemptions',
             ownerInfo.exemptions,'totalExemptions'), changeCalculatedTaxValues()}"
             :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             ></v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input" hide-details
            @focus="amountToNum('exemptions'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'exemptions',
            'totalExemptions'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             v-model.number="afterAdjustment.exemptions" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3" class="pt-0 pb-0">
            <label class="input-text-size">Tax Amount</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0 label-align">
            <label class="input-text-size">{{ownerInfo.totalTax}}</label>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size right-aligned-input pa-0"
            hide-details
            v-model.number="editedItem.taxAmt"
            :value="adjustmentDifferent.taxAmt"
            @focus="amountToNumAdjustsVal('taxAmt'), $event.target.select()"
            @blur="(e)=>{adjustmentsValues(e.target.value,'totalTax',
            ownerInfo.totalTax,'taxAmt'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
            ></v-text-field>
          </v-col>
          <v-col cols="3" class="pt-0 pb-0">
            <v-text-field class="input-text-size pa-0 right-aligned-input"
            @focus="amountToNum('totalTax'), $event.target.select()"
            @blur="(e)=>{handleAfterAdjustment(e.target.value,'totalTax',
            'taxAmt'), changeCalculatedTaxValues()}"
            :readonly="isDisableAdjValues" :tabindex="isDisableAdjValues ? -1 : 0"
             v-model.number="afterAdjustment.totalTax"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="2" class="d-flex justify-space-between">
            <label class="input-text-size">SD/Levy :
              {{ ownerInfo.schoolDistrict || editedItem.schoolDistrict }}</label>

          </v-col>

          <v-col cols="3" class="d-flex justify-space-between ">
            <label class="input-text-size red--text">Total Levies: </label>
            <label class="input-text-size">{{ this.totalLevies}}</label>
             <label class="input-text-size red--text">Gross Assessed</label>

          </v-col>
          <v-col cols="4" class="d-flex justify-space-between">
             <label class="input-text-size">{{this.grossAssessed}}</label>
            <label class="input-text-size red--text">Net Assessed:</label>
            <label class="input-text-size ">{{this.netAssessed}}</label>
          </v-col>
          <v-col cols="3" class="d-flex justify-space-between">
          <label class="input-text-size red--text">Calculated Tax Amount:</label>
          <label class="input-text-size">
            {{this.calculatedTaxAmount}}</label>
          </v-col>
        </v-row>
        <v-textarea class="input-text-size pt-3 pa-0" label="Comments"
        v-textAreaUppercase=globalSettingItem.conEverythingToCaps
          v-model="editedItem.comments" outlined rows="3" />
      </v-col>

      <!-- Delete Confirmation Dialog -->
      <v-dialog
        v-model="deleteConfirmDialog"
        persistent
        max-width="450"
      >
        <v-card>
          <v-card-title class="text-h5 warning--text">
            <v-icon color="warning" class="mr-2">{{ mdiAlert }}</v-icon>
            Confirm Delete
          </v-card-title>
          <v-card-text class="input-text-size">
            Are you sure you want to delete this tax roll adjustment record?
            <br /><br />
            <strong>Tax Year:</strong> {{ editedItem.taxYear }}<br />
            <strong>Tax ID:</strong> {{ editedItem.taxId }}<br />
            <strong>Type:</strong> {{ editedItem.type }}
            <br /><br />
            <span class="error--text">This action cannot be undone.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="deleteConfirmDialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="error"
              text
              @click="confirmDelete"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
      v-model="dialogCert"
          persistent
          max-width="400"
        >
        <v-card>
          <v-card-title class="text-h5">
            Duplicate Cert Number Used
          </v-card-title>
          <v-card-text>{{ dialogeMessage }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :disabled="isSaving"
              @click="dialogCert = false, continueSubmit=true, upsrtTransaction()"
            >
              Continue
            </v-btn>

            <v-btn
              text
              @click="dialogCert = false,continueSubmit = false"
            >
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
      <h4 class="input-text-size red--text text-center"
      v-if="checkIfWarningIsThereOrNot">WARNING: TAX AMOUNT DOES NOT MATCH CALCULATED AMOUNT</h4>
    </div>
</template>
<script>
import { mdiAlert, mdiDelete } from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { toShortDate } from '../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import CommonDropDowns from './CommonDropDowns.mixin.vue';
import { parseLocalDate } from './tax-common.util';

const taxRollTypeCrudKey = 'taxAdjTypesList';

export default {
  name: 'CommonTaxRollAdjustmentsDialogForm',
  mixins: [GlobalToCaps],
  components: {
    ClarionDateControl,
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxRollAdjustmentsList',
    },
    disabledPosted: {
      type: Boolean,
      default: true,
    },
    rulesEnableDiable: {
      type: Boolean,
      default: false,
    },
    upsrtTransaction: {
      type: Function,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    handleLoadCRUDList: {
      type: Function,
    },
  },
  mounted() {
    // when the dialog is opened, watch wont work, so we need to set the date here
    if (this.editedItem._id) {
      this.intDate = {
        adjDate: toShortDate(),
        certDate: toShortDate(),
        filedDate: toShortDate(),
      };
    } else {
      this.intDate = {
        adjDate: toShortDate(),
        certDate: toShortDate(),
      };
    }
  },
  data() {
    return {
      mdiAlert,
      mdiDelete,
      deleteConfirmDialog: false,
      disableAfAdjustment: false,
      totalLevies: 0,
      grossAssessed: 0,
      netAssessed: 0,
      calculatedTaxAmount: 0,
      dialogCert: false,
      dialogeMessage: '',
      continueSubmit: false,
      ownerInfo: {
        name: '',
        land: 0,
        improvements: 0,
        mobileHome: 0,
        exemptions: 0,
        totalTax: 0,
        schoolDistrict: '',
        assessorPenalty: 0,
      },
      afterAdjustment: {
        land: 0,
        improvements: 0,
        mobileHome: 0,
        exemptions: 0,
        totalTax: 0,
        assessorPenalty: 0,
      },
      adjustmentDifferent: {
        landVal: 0,
        improvementVal: 0,
        mobileVal: 0,
        penaltyVal: 0,
        totalExemptions: 0,
        taxAmt: 0,
      },
      intDate: {
        adjDate: toShortDate(),
        certDate: toShortDate(),
      }, // using this somehow store item updated value is not refelecting in clarionDate
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    ...mapGetters(['todaysDate']),
    ...mapState({
      adjUpdTypes: (state) => state.enums.TaxRollAdjustUpdateEnum,
      lockedValues: (state) => state.tax.taxRollAdjustments.lockedValues,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    isDialogVisible() {
      return this.isVisible(this.baseCrudKey);
    },
    isNewItem() {
      return this.index(this.baseCrudKey) === -1;
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isNewRecord() {
      return !this.editedItem._id;
    },

    isDisableAdjValues() {
      const postedStatus = this.editedItem.posted;
      if (!this.isNewRecord && postedStatus !== undefined && (postedStatus === 'Y' || postedStatus === true)) {
        return true;
      }
      if (this.editedItem.adjOrUpd !== 'ADJUST') {
        return true;
      }
      return false;
    },

    taxRollTypes() {
      const typeList = this.items(taxRollTypeCrudKey) || [];
      return typeList;
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    certRules() {
      if (this.rulesEnableDiable) {
        return [
          (v) => !!v || 'Required.',
          () => true,
        ];
      }
      return [() => true];
    },
    adjRules() {
      return [
        (v) => {
          if (v) {
            if (!this.taxSettingItem.curPostPerFromDate || !this.taxSettingItem.curPostPerToDate) {
              return 'Required Posting Period from Tax-setting';
            }
            const from = parseLocalDate(this.taxSettingItem.curPostPerFromDate);
            const to = parseLocalDate(this.taxSettingItem.curPostPerToDate);
            const check = parseLocalDate(v);
            const isDateValid = from && to && check
              && !Number.isNaN(from.getTime())
              && !Number.isNaN(to.getTime())
              && !Number.isNaN(check.getTime());
            // Validated for BOTH consumers. This used to be skipped whenever
            // isItFromTaxInquiry was false, on the theory that adjustments not created from
            // tax-info are unposted and so need no check. That theory is wrong - the
            // standalone Tax Roll Adjustments screen, where the date IS user-editable, does
            // not pass the prop (it defaults to false), so it had no date validation at all,
            // and all 125 of the Comanche supplements that landed in a closed July were
            // posted:true. Backed by the server-side guard in the upsertTaxRollAdjustments
            // resolver; this rule just surfaces it before the user hits Save.
            if (isDateValid && check >= from && check <= to) {
              return true;
            }
            return 'The Date has to be within the posting period';
          }
          return !!v || 'Required.';
        },
        () => true,
      ];
    },
    required() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    checkIfWarningIsThereOrNot() {
      if (amountToNumber(this.calculatedTaxAmount)
       === amountToNumber(this.afterAdjustment.totalTax)) {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
      'setIsVisible',
    ]),
    ...mapMutations('tax/taxRollAdjustments', [
      'setLockedValues',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'bulkDeleteAdjustments',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'calculateTaxes',
    ]),
    ...mapActions(['custumColrFlashMsg']),
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'taxAdjTypesList') this.editedItem.type = val;
      else this.editedItem[whichField] = val;
      if (whichField === 'taxYear' && this.editedItem.taxId) this.handleTaxRollRecords();
    },
    showDeleteConfirmation() {
      if (!this.editedItem._id) {
        return;
      }
      this.deleteConfirmDialog = true;
    },
    async confirmDelete() {
      this.deleteConfirmDialog = false;
      const upsert = {
        _ids: [this.editedItem._id],
      };
      await this.bulkDeleteAdjustments({ upsert });

      // Close the CRUD dialog
      this.setIsVisible([this.baseCrudKey, false]);

      this.handleLoadCRUDList();
    },
    openDilaog() {
      this.dialogCert = !this.dialogCert;
    },
    // setDefaultEditedItem() {
    //   this.handleTaxInfo();
    //   this.editedItem.adjDate = toIsoDate(this.todaysDate);
    //   this.editedItem.certDate = toIsoDate(this.todaysDate);
    // },
    async handleTaxInfo() {
      const taxInfo = this.item(this.taxRollBaseCrudKey);
      const { taxYear, taxId } = taxInfo;
      if (taxYear && taxId) {
        this.editedItem = {
          taxYear,
          taxId,
        };
        await this.handleTaxRollRecords();
      }
    },
    async handleCalculatedTax({
      land,
      improvements,
      mobileHome,
      exemptions,
      totalTax,
      penalty,
      schoolDistrict,
    }) {
      const { taxYear } = this.editedItem;
      if (!taxYear) {
        this.editedItem.taxYear = this.latestTaxYear;
      }
      const criteria = {
        land: amountToNumber(land),
        improvements: amountToNumber(improvements),
        mobileHome: amountToNumber(mobileHome),
        exemptions: amountToNumber(exemptions),
        totalTax: amountToNumber(totalTax),
        schoolDistrict: schoolDistrict || this.editedItem.schoolDistrict,
        taxYear: taxYear || this.latestTaxYear,
        penalty,
      };
      const response = await this.calculateTaxes({ criteria });
      this.totalLevies = amountFormat(response.totalLevies);
      this.grossAssessed = amountFormat(response.grossAssessed);
      this.netAssessed = amountFormat(response.netAssessed);
      this.calculatedTaxAmount = amountFormat(response.calculatedTax);
      return response;
    },
    // The six value rows are readonly rather than disabled once the adjustment is posted (or it
    // is an UPDATE rather than an ADJUST), so a plain click still focuses them and runs their
    // @focus/@blur pair. Every one of these rewrites editedItem / afterAdjustment - and
    // changeCalculatedTaxValues goes on to call the tax recalculation - so they all bail out
    // while the row is locked and leave the posted figures exactly as they were read.
    adjustmentsValues(value, updatedField, beforeValues, currentField) {
      if (this.isDisableAdjValues) return;
      const afterAdjustmentValue = amountToNumber(value) + amountToNumber(beforeValues);
      this.afterAdjustment[updatedField] = amountFormat(afterAdjustmentValue);
      this.editedItem[currentField] = amountFormat(value);
      this.adjustmentDifferent[currentField] = amountFormat(value);
    },
    loadAfterAdjustment(field, val) {
      if (val < 0) {
        // if value is negative then need to perform plus operator for subtracting
        // eslint-disable-next-line operator-assignment, max-len
        this.afterAdjustment[field] = amountFormat(amountToNumber(this.ownerInfo[field]) + (parseFloat(val, 10)));
      } else {
        // eslint-disable-next-line operator-assignment, max-len
        this.afterAdjustment[field] = amountFormat(amountToNumber(this.ownerInfo[field]) - (parseFloat(val, 10) || 0));
      }
    },

    async handleTaxRollRecords() {
      // Tax ID is readonly rather than disabled on a saved record, so its @blur can now fire
      // there. Re-reading the tax roll would overwrite ownerInfo and the before-adjustment
      // figures on a record that is already keyed to them, so only run it while entering one.
      if (this.editedItem._id) return;
      if (this.editedItem.taxYear && this.editedItem.taxId) {
        this.disableAfAdjustment = false;
        const criteria = { taxYear: this.editedItem.taxYear, taxId: this.editedItem.taxId };
        const data = await this.loadTaxInquires({ criteria, baseCrudKey: 'adjustmentDialog' });
        if (data.length) {
          const [adjustmentItem] = (data || []);
          this.ownerInfo.name = `${adjustmentItem.name1 || ''} ${adjustmentItem.name2 || ''}`;
          this.ownerInfo.land = amountFormat(adjustmentItem.land || 0);
          this.ownerInfo.improvements = amountFormat(adjustmentItem.improvements || 0);
          this.ownerInfo.mobileHome = amountFormat(adjustmentItem.mobileHome || 0);
          this.ownerInfo.exemptions = amountFormat(adjustmentItem.exemptions || 0);
          this.ownerInfo.totalTax = amountFormat(adjustmentItem.totalTax || 0);
          this.ownerInfo.schoolDistrict = adjustmentItem.schoolDistrict || '';
          this.ownerInfo.assessorPenalty = amountFormat(adjustmentItem.assessorPenalty || 0);
          const {
            landVal, improvementVal, mobileVal, penaltyVal, taxAmt, totalExemptions, schoolDistrict,
          } = this.editedItem;

          this.loadAfterAdjustment('land', landVal || 0);
          this.loadAfterAdjustment('improvements', improvementVal || 0);
          this.loadAfterAdjustment('mobileHome', mobileVal || 0);
          this.loadAfterAdjustment('exemptions', totalExemptions || 0);
          this.loadAfterAdjustment('totalTax', taxAmt || 0);
          this.loadAfterAdjustment('assessorPenalty', penaltyVal || 0);
          this.assignSchoolDistrict(adjustmentItem.schoolDistrict);

          const {
            land, improvements, mobileHome, exemptions, totalTax, assessorPenalty,
          } = this.afterAdjustment;
          await this.handleCalculatedTax({
            land,
            improvements,
            mobileHome,
            exemptions,
            totalTax,
            schoolDistrict,
            penalty: amountToNumber(assessorPenalty),
          });
        } else {
          this.custumColrFlashMsg({ msg: 'No records found' });
          this.ownerInfo.name = '';
          this.ownerInfo.land = 0;
          this.ownerInfo.improvements = 0;
          this.ownerInfo.mobileHome = 0;
          this.ownerInfo.exemptions = 0;
          this.ownerInfo.totalTax = 0;
          this.ownerInfo.schoolDistrict = '';
          this.ownerInfo.assessorPenalty = 0;
        }
      }
    },
    assignSchoolDistrict(value) {
      this.editedItem.schoolDistrict = value;
    },
    amountToNum(currentField) {
      if (this.isDisableAdjValues) return;
      this.afterAdjustment[currentField] = amountToNumber(this.afterAdjustment[currentField]);
    },
    amountToNumAdjustsVal(currentField) {
      if (this.isDisableAdjValues) return;
      this.adjustmentDifferent[currentField] = amountToNumber(
        this.adjustmentDifferent[currentField],
      );
      this.editedItem[currentField] = amountToNumber(this.editedItem[currentField]);
    },
    handleAfterAdjustment(value, currentField, adjustmentField) {
      if (this.isDisableAdjValues) return;
      const val = amountToNumber(value) - amountToNumber(this.ownerInfo[currentField] || 0);
      this.editedItem[adjustmentField] = amountFormat(val);
      this.adjustmentDifferent[adjustmentField] = amountFormat(val);
      this.afterAdjustment[currentField] = amountFormat(this.afterAdjustment[currentField]);
    },
    handleAdjOrUpd(value) {
      if (value === 'UPDATE') {
        this.disableAfAdjustment = true;
      } else if (this.editedItem.posted !== 'Y') {
        this.disableAfAdjustment = false;
      }
    },
    formatAmountToNumber(type) {
      if (type === 'ownerInfo') {
        this.ownerInfo = {
          assessorPenalty: amountFormat(this.editedItem.valuesBeforeAdjustment.assessorPenalty),
          land: amountFormat(this.editedItem.valuesBeforeAdjustment.land),
          improvements: amountFormat(this.editedItem.valuesBeforeAdjustment.improvements),
          mobileHome: amountFormat(this.editedItem.valuesBeforeAdjustment.mobileHome),
          exemptions: amountFormat(this.editedItem.valuesBeforeAdjustment.exemptions),
          totalTax: amountFormat(this.editedItem.valuesBeforeAdjustment.totalTax),

        };
      } else if (type === 'afterAdjustment') {
        this.afterAdjustment = {
          assessorPenalty: amountFormat(this.editedItem.valuesAfterAdjustment.assessorPenalty),
          land: amountFormat(this.editedItem.valuesAfterAdjustment.land),
          improvements: amountFormat(this.editedItem.valuesAfterAdjustment.improvements),
          mobileHome: amountFormat(this.editedItem.valuesAfterAdjustment.mobileHome),
          exemptions: amountFormat(this.editedItem.valuesAfterAdjustment.exemptions),
          totalTax: amountFormat(this.editedItem.valuesAfterAdjustment.totalTax),

        };
      }
    },
    dateChangeFunc(val, varName) {
      this.intDate[varName] = val;
      this.editedItem[varName] = val;
    },
    handleNewRecordClick() {
      this.editedItem.adjDate = toShortDate();
      this.editedItem.certDate = toShortDate();
      this.intDate.adjDate = toShortDate();
      this.intDate.certDate = toShortDate();
    },

    async changeCalculatedTaxValues() {
      if (this.isDisableAdjValues) return;
      const {
        land, improvements, mobileHome, exemptions, totalTax, assessorPenalty,
      } = this.afterAdjustment;
      const schoolDistrict = ((this.editedItem.valuesBeforeAdjustment || {}).schoolDistrict) || '';
      await this.handleCalculatedTax({
        land,
        improvements,
        mobileHome,
        exemptions,
        totalTax,
        schoolDistrict,
        penalty: amountToNumber(assessorPenalty),
      });
    },
    async handleEditRecordClick() {
      if (this.editedItem.valuesAfterAdjustment !== null) {
        this.formatAmountToNumber('ownerInfo');
        this.formatAmountToNumber('afterAdjustment');
        const land = this.editedItem.valuesAfterAdjustment.land || 0;
        const improvements = this.editedItem.valuesAfterAdjustment.improvements || 0;
        const mobileHome = this.editedItem.valuesAfterAdjustment.mobileHome || 0;
        const exemptions = this.editedItem.valuesAfterAdjustment.exemptions || 0;
        const totalTax = this.editedItem.valuesAfterAdjustment.totalTax || 0;
        const assessorPenalty = this.editedItem.valuesAfterAdjustment.assessorPenalty || 0;
        const schoolDistrict = this.editedItem.valuesBeforeAdjustment.schoolDistrict || '';
        const adjDateVal = this.editedItem.adjDate ? toShortDate(this.editedItem.adjDate)
          : this.editedItem.adjDate;
        const filedDateVal = this.editedItem.filedDate ? toShortDate(this.editedItem.filedDate)
          : this.editedItem.filedDate;
        const certDateVal = this.editedItem.certDate ? toShortDate(this.editedItem.certDate)
          : this.editedItem.certDate;
        this.editedItem.adjDate = adjDateVal;
        this.editedItem.filedDate = filedDateVal;
        this.editedItem.certDate = certDateVal;
        this.intDate.adjDate = adjDateVal;
        this.intDate.filedDate = filedDateVal;
        this.intDate.certDate = certDateVal;
        await this.handleCalculatedTax({
          land,
          improvements,
          mobileHome,
          exemptions,
          totalTax,
          schoolDistrict,
          penalty: amountToNumber(assessorPenalty),
        });
      } else {
        const adjDateVal = this.editedItem.adjDate ? toShortDate(this.editedItem.adjDate)
          : this.editedItem.adjDate;
        const filedDateVal = this.editedItem.filedDate ? toShortDate(this.editedItem.filedDate)
          : this.editedItem.filedDate;
        const certDateVal = this.editedItem.certDate ? toShortDate(this.editedItem.certDate)
          : this.editedItem.certDate;
        this.intDate.adjDate = adjDateVal;
        this.intDate.filedDate = filedDateVal;
        this.intDate.certDate = certDateVal;
        this.handleTaxRollRecords();
      }

      const postedStatus = this.editedItem.posted;
      if (postedStatus !== undefined && (postedStatus === 'Y' || postedStatus === true)) {
        this.disableAfAdjustment = true;
      } else {
        this.disableAfAdjustment = false;
      }
    },
    // trigerInfoForceFully(taxYear, adjDate, certDate) {
    //   this.editedItem.taxYear = taxYear;
    //   this.editedItem.adjDate = adjDate;
    //   this.editedItem.certDate = certDate;
    // },
  },
  watch: {
    isDialogVisible(val) {
      // this helps to edit the filed date
      if (val) {
        if (this.editedItem._id) {
          this.intDate = {
            adjDate: toShortDate(),
            certDate: toShortDate(),
            filedDate: toShortDate(),
          };
        } else {
          this.intDate = {
            adjDate: toShortDate(),
            certDate: toShortDate(),
          };
        }
      }
    },
  },
};
</script>
